module.exports = __webpack_public_path__ + "static/media/tenge.a3b2e1ca.svg";